import { MLProductCodeUtil } from 'ml-portals-util-js';
import MLSaveSessionService from './MLSaveSessionService';
import messages from './MLSideMenuItemsService.messages';
/**
 * This service defines:
 * - The marketing info items that will be displayed in the side menu of the AMP landing page.
 * - A function to retrieve these items.
//  */
let policyPeriodSummaries;
    
const coverageChangeAction = (coverage, logicFn)=> {
    MLSaveSessionService.setSessionValue('SINGLE_ENDORSEMENT_COVERAGE', coverage);
    MLSaveSessionService.setSessionValue('SHOULD_USE_SINGLE_ENDORSEMENT_COVERAGE', logicFn);
    window.location.href = `${window.location.origin}/account-management/policies`;
};
const vppCoverageAction = (logicFn) => () => coverageChangeAction('VPP', logicFn);
const extraCoverageAction = (logicFn) => () => coverageChangeAction('Extra', logicFn);
const piCoverageAction = (logicFn) => () => coverageChangeAction('PI', logicFn);
const hspCoverageAction = (logicFn) => () => coverageChangeAction('HSP', logicFn);
const autoExtraCoverageAction = (logicFn) => () => coverageChangeAction('AUTO_EXTRA', logicFn);
const travelPkgCoverageAction = (logicFn) => () => coverageChangeAction('TRAVEL_PKG', logicFn);
const buildersCoverageAction = (logicFn) => () => coverageChangeAction('BUILDERS', logicFn);
const externalLinkAction = (link) => window.open(link, '_blank');
    
const isPeriodInforce = (period) => period.status === 'Active';
const isHOPPeriodInforce = (period) =>  MLProductCodeUtil.isHomeOwners(period.product_ML.publicID) && isPeriodInforce(period)
const isPersonalAutoInforce = (period) => MLProductCodeUtil.isPersonalAuto(period.product_ML.publicID) && isPeriodInforce(period);
const isPersonalUmbrellaInforce = (period) => MLProductCodeUtil.isPersonalUmbrella(period.product_ML.publicID) && isPeriodInforce(period);
const isDwellingInforce = (period) => MLProductCodeUtil.isHomeOwnersPartialTypeHome(period.coveragePartType_ML) && isPeriodInforce(period);
const isCondoInforce = (period) => MLProductCodeUtil.isHomeOwnersPartialTypeCondo(period.coveragePartType_ML) && isPeriodInforce(period);
const isRentersInforce = (period) => MLProductCodeUtil.isHomeOwnersPartialTypeRental(period.coveragePartType_ML) && isPeriodInforce(period);
const hasAnyPersonalAutoPolicies = () => policyPeriodSummaries.some(isPersonalAutoInforce);
const hasAnyHOPPolicies = () => policyPeriodSummaries.some(isHOPPeriodInforce);
const hasAnyDwellingPolicies = () => policyPeriodSummaries.some(isDwellingInforce);
const hasAnyCondoPolicies = () => policyPeriodSummaries.some(isCondoInforce);
const hasAnyRentersPolicies = () => policyPeriodSummaries.some(isRentersInforce);
const hasAnyUMBPolicies = () => policyPeriodSummaries.some(isPersonalUmbrellaInforce);
const hasIAProducer = () => {
    return policyPeriodSummaries.some((period) => {
        return period.producerCodeType_Ext === 'ia';
    });
};
const getPAPolicies = () => policyPeriodSummaries.filter(isPersonalAutoInforce);
const getHOPPolicies = () => policyPeriodSummaries.filter(isHOPPeriodInforce);
const getDwellingPolicies = () => policyPeriodSummaries.filter(isDwellingInforce);
const getCondoPolicies = () => policyPeriodSummaries.filter(isCondoInforce);
const getRentersPolicies = () => policyPeriodSummaries.filter(isRentersInforce);


const policyDoesntHaveVPP = (p) => isHOPPeriodInforce(p) && !p.ampsideMenuFlags_ML.hasVPPCoverage_ML;
const policyDoesntHaveSpeciality = (p) => isHOPPeriodInforce(p) && !p.ampsideMenuFlags_ML.hasSpecialtyCoverage_ML;
const policyDoesntHavePI = (p) => isHOPPeriodInforce(p) && !p.ampsideMenuFlags_ML.hasPersonalInjuryCoverage_ML;
const dwellingDoesntHaveHSP = (p) => isDwellingInforce(p) && !p.ampsideMenuFlags_ML.hasHomeSystemsProtection;
const condoOrRentersDoesntHaveSP = (p) => (isCondoInforce(p) || isRentersInforce(p)) && !p.ampsideMenuFlags_ML.hasHomeSystemsProtection;
const hoDoesntHaveBuilders = (p) => isHOPPeriodInforce(p) && !p.ampsideMenuFlags_ML.hasTheftOfBuildingMaterials;
const autoDoesntHaveTravel = (p) => isPersonalAutoInforce(p) && (!p.ampsideMenuFlags_ML || !p.ampsideMenuFlags_ML.hasTravelPkgOption);
const autoDoesntHaveExtra = (p) => isPersonalAutoInforce(p) && (!p.ampsideMenuFlags_ML || !p.ampsideMenuFlags_ML.hasAutoExtraOption);
        
const WEIGHT_MAX = 100; 
const WEIGHT_90 = 90; 
const WEIGHT_80 = 80; 
const WEIGHT_70 = 70; 
const WEIGHT_60 = 60; 
const WEIGHT_50 = 50; 
const WEIGHT_40 = 40; 
const WEIGHT_30 = 30; 

/**
         * Cross sell tiles, which are given precedence over all others
         */
const mainItems = [{
    /* Always show unless any HOP, Landlord Home, Condo, Landlord Condo, Renter's policy is inforce with auto policy on the same account.  */
    title: messages.autoInsuranceTitle,
    verbiage: messages.autoInsuranceVerbiage,
    buttonText: messages.quoteButtonText,
    action: () => externalLinkAction('http://www.farmers.com/landing/groupselect/getquote'),
    visible: () => {
        return !hasAnyPersonalAutoPolicies() && !hasIAProducer();;
    },
    weight: () => {
        if (hasAnyUMBPolicies()) {
            return WEIGHT_60; 
        }

        return WEIGHT_90; 
    }
}, {
    /* Always show unless any HOP or Auto policy or HOP & Auto policy is inforce with an Umbrella policy on the same account  */
    title: messages.umbrellaInsuranceTitle,
    verbiage: messages.umbrellaInsuranceVerbiage,
    buttonText: messages.quoteButtonText,
    action: () => externalLinkAction('http://www.farmers.com/landing/groupselect/getquote'),
    visible: () => {
        return !hasAnyUMBPolicies() && !hasIAProducer();
    },
    weight: () => WEIGHT_50
}, {
    /* Show for any Auto policies without Home, condo or renter's policy on the same account (account = 1 customer)  */
    title: messages.homeInsuranceTitle,
    verbiage: messages.homeInsuranceVerbiage,
    buttonText: messages.quoteButtonText,
    action: () => externalLinkAction('http://www.farmers.com/landing/groupselect/getquote'),
    visible: () => {
        return !hasAnyDwellingPolicies() && !hasAnyCondoPolicies() && !hasAnyRentersPolicies() && !hasIAProducer();; 
    },
    weight: () => WEIGHT_MAX
}];
    
// List of items that will be displayed randomly;
const randomMenuItems = [{
    /* Show unless any HOP policy is inforce with VPP coverage */
    title: messages.valuableCoverageTitle,
    verbiage: messages.valuableCoverageVerbiage,
    buttonText: messages.addCoverageButtonText,
    action: vppCoverageAction(policyDoesntHaveVPP),
    visible: () => {
        return hasAnyHOPPolicies() && !getHOPPolicies().some((p) => !policyDoesntHaveVPP(p));
    },
    weight: () => WEIGHT_80
}, {
    /* Show unless any HOP policy is inforce with any of the specialty coverage packages (blankets) */
    title: messages.specialtyItemsCoverageTitle,
    verbiage: messages.specialtyItemsCoverageVerbiage,
    buttonText: messages.addCoverageButtonText,
    action: extraCoverageAction(policyDoesntHaveSpeciality),
    visible: () => {
        return hasAnyHOPPolicies() && !getHOPPolicies().some((p) => !policyDoesntHaveSpeciality(p));
    },
    weight: () => WEIGHT_50
}, {
    /* Show unless any HOP policy is inforce with personal injury coverage */
    title: messages.digitalWorldProtectionTitle,
    verbiage: messages.digitalWorldProtectionVerbiage,
    buttonText: messages.addCoverageButtonText,
    action: piCoverageAction(policyDoesntHavePI),
    visible: () => {
        return hasAnyHOPPolicies() && !getHOPPolicies().some((p) => !policyDoesntHavePI(p));
    },
    weight: () => WEIGHT_40
}, {
    /* Show unless any HOP (exclude Condo & Renter's) policy is inforce with Home Systems protection option */
    title: messages.homeSystemsProtectionTitle,
    verbiage: messages.homeownerSystemsVerbiage,
    buttonText: messages.addCoverageButtonText,
    action: hspCoverageAction(dwellingDoesntHaveHSP),
    visible: () => {
        return hasAnyDwellingPolicies() && !getDwellingPolicies().some((p) => !dwellingDoesntHaveHSP(p));
    },
    weight: () => WEIGHT_70
}, {
    /* Show unless any HOP (exclude Condo & Renter's) policy is inforce with Home Systems protection option */
    title: messages.homeSystemsProtectionTitle,
    verbiage: messages.homeRenterSystemsVerbiage,
    buttonText: messages.addCoverageButtonText,
    action: hspCoverageAction(condoOrRentersDoesntHaveSP),
    visible: () => {
        const condoAndRentersPolicies = [...getCondoPolicies(), ...getRentersPolicies()];
        return (hasAnyCondoPolicies() || hasAnyRentersPolicies()) && !condoAndRentersPolicies.some((p) => !condoOrRentersDoesntHaveSP(p));
    },
    weight: () => WEIGHT_70
}, {
    /* Show unless any Auto policy is already inforce with the  specialty Auto Extra Option */
    title: messages.autoExtraTitle,
    verbiage: messages.autoExtraVerbiage,
    buttonText: messages.addCoverageButtonText,
    action: autoExtraCoverageAction(autoDoesntHaveExtra),
    visible: () => {
        return hasAnyPersonalAutoPolicies() && !getPAPolicies().some((p) => !autoDoesntHaveExtra(p)); 
    },
    weight: () => WEIGHT_60
}, {
    /* Show unless any Auto policy is already inforce with the Travel Pkg Option */
    title: messages.travelPackageTitle,
    verbiage: messages.travelPackageVerbiage,
    buttonText: messages.addCoverageButtonText,
    action: travelPkgCoverageAction(autoDoesntHaveTravel),
    visible: () => {
        return hasAnyPersonalAutoPolicies() && !getPAPolicies().some((p) => !autoDoesntHaveTravel(p)); 
    },
    weight: () => WEIGHT_90
}, {
    /* Show unless any NB HOP policy is inforce with Theft of Building Materials coverage option or if policy indicates "under construction" and does not have Theft of Building Materials coverage option */
    title: messages.theftOfBuildingMaterialCoverageTitle,
    verbiage: messages.theftOfBuildingMaterialVerbiage,
    buttonText: messages.addCoverageButtonText,
    action: buildersCoverageAction(hoDoesntHaveBuilders),
    visible: () => {
        return hasAnyHOPPolicies() && !getHOPPolicies().some((p) => !hoDoesntHaveBuilders(p));
    },
    weight: () => WEIGHT_30
}];
/*
         * Returns at most n random items listed in 'menuItems'.
         * Items with highest weight have higher probability to be picked.
         */
const getWeightedRandomItems = (from, n) => {
    const results = [];
    const possibleItems = from.filter((item) => 
        item.visible());
    
    for (let i = 0; i < n; i++) {
        if (possibleItems.length > 0) {
            const totalWeight = possibleItems.reduce((value, item) => {
                return value + item.weight();
            }, 0);
            const randomNum = Math.floor(Math.random() * totalWeight) + 1;
            let weightSum = 0;
    
            for (let j = 0; j < possibleItems.length; j++) {
                weightSum += possibleItems[j].weight();
    
                if (randomNum <= weightSum) {
                    results.push(possibleItems[j]);
                    possibleItems.splice(j, 1);
                    break;
                }
            }
        }
    
    }
    return results;
};
    
// Returns an array all the policy period summaries contained in the policySummaries passed as an argument
const flatPolicyPeriodSummaries = (policySummaries) => {
    if (policySummaries && policySummaries.length > 0) {
        return policySummaries.reduce((periodSummaries, currentPolicy) => {
            return currentPolicy.periods && currentPolicy.periods.length > 0
                ? [...periodSummaries, ...currentPolicy.periods]
                : periodSummaries;
        }, []);
    }
    return [];
};
    
export default {
            
    /**
    * Returns at most n items, composed of all applicable main items
    * with the remainder made up of random items. 
    */
    getItems: (n, policySummaries) => {
        policyPeriodSummaries = flatPolicyPeriodSummaries(policySummaries);
        const pickedMainItems = getWeightedRandomItems(mainItems, n);
        const remainderToPick = n - pickedMainItems.length; 
        const pickedRandomItems = remainderToPick > 0 ? getWeightedRandomItems(randomMenuItems, remainderToPick) : [];

        return [...pickedMainItems, ...pickedRandomItems];
    }
};
//     }];
// });